import { ThunkAction } from 'redux-thunk';
import { AnyAction } from 'redux';
import { AppState } from '../../store';
import { setCookie } from '../../utils/cookie';

export const saveQueryParamsToCookie = (): ThunkAction<
  {},
  AppState,
  {},
  AnyAction
> => async (dispatch, getState) => {
  const {
    organizationId,
    contractInfoId,
    usageInfoId,
    peopleId
  } = getState().property.property;

  if (organizationId !== undefined) {
    setCookie('organization_id', organizationId);
  }
  setCookie('contract_info_id', contractInfoId || '');
  setCookie('usage_info_id', usageInfoId);
  if (peopleId !== undefined) {
    setCookie('people_id', peopleId);
  }
};
